(() => {
  const source = document.currentScript;
  const main = document.getElementById('MainContent');
  if (!main) return;
  const key = 'monolith-product-navigation-v2';
  const locale = document.documentElement.lang;
  function safeUrl(value) {
    const url = new URL(value, location.origin);
    return url.origin === location.origin ? url : null;
  }
  if (source.dataset.productHandle) {
    const anchor = main.querySelector('[data-monolith-nav-anchor]');
    if (!anchor || main.querySelector('.monolith-product-nav')) return;
    let state;
    try { state = JSON.parse(sessionStorage.getItem(key)); } catch { return; }
    if (!state || state.locale !== locale || Date.now() - state.time > 1800000 || !Array.isArray(state.products)) return;
    const index = state.products.findIndex(p => p.handle === source.dataset.productHandle);
    if (index < 0 || state.products.length < 2) return;
    const backUrl = safeUrl(state.back);
    if (!backUrl || !backUrl.pathname.includes('/collections/')) return;
    const nav = document.createElement('nav');
    nav.className = 'monolith-product-nav';
    nav.setAttribute('aria-label', anchor.dataset.navLabel);
    const makeSide = (product, side, label) => {
      const container = document.createElement('div');
      container.className = 'monolith-product-nav__' + side;
      if (!product) return container;
      const url = safeUrl(product.url);
      if (!url || !url.pathname.includes('/products/')) return container;
      const link = document.createElement('a');
      link.href = url.pathname + url.search;
      link.rel = side === 'previous' ? 'prev' : 'next';
      const arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = side === 'previous' ? '←' : '→';
      const text = document.createElement('span');
      const heading = document.createElement('span');
      heading.className = 'monolith-product-nav__label';
      heading.textContent = label;
      const title = document.createElement('span');
      title.className = 'monolith-product-nav__title';
      const normalized = product.title.replace(/[„“”«»]/g, '"');
      const quoted = normalized.match(/"[^"]+"/g);
      title.textContent = quoted ? quoted.join(' ') : product.title;
      text.append(heading, title);
      let img;
      if (product.image) {
        const imageUrl = new URL(product.image, location.origin);
        if (imageUrl.protocol === 'https:') {
          img = document.createElement('img');
          img.src = imageUrl.href;
          img.alt = '';
          img.width = 56;
          img.height = 56;
          img.className = 'monolith-product-nav__image';
        }
      }
      if (side === 'previous') {
        link.append(arrow);
        if (img) link.append(img);
        link.append(text);
      } else {
        link.append(text);
        if (img) link.append(img);
        link.append(arrow);
      }
      container.append(link);
      return container;
    };
    const back = document.createElement('a');
    back.className = 'monolith-product-nav__collection';
    back.href = backUrl.pathname + backUrl.search;
    back.textContent = anchor.dataset.collectionLabel;
    nav.append(makeSide(state.products[index - 1], 'previous', anchor.dataset.previousLabel), back, makeSide(state.products[index + 1], 'next', anchor.dataset.nextLabel));
    anchor.after(nav);
    return;
  }
  const collectionPath = source.dataset.collectionPath;
  if (!collectionPath) return;
  const collectionUrl = safeUrl(collectionPath);
  if (!collectionUrl) return;
  const dynamicCollection = /\/(vendors|types)\/?$/.test(collectionUrl.pathname);
  const allowedHandles = source.dataset.productHandles ? source.dataset.productHandles.split('|') : null;
  let products = [];
  try { products = JSON.parse(document.getElementById('monolith-nav-products')?.textContent || '[]'); } catch {}
  function productHandle(link) {
    const url = safeUrl(link.href);
    return url?.pathname.match(/\/products\/([^/]+)\/?$/)?.[1];
  }
  function updateLink(link) {
    const url = safeUrl(link.href);
    if (!url) return;
    const handle = productHandle(link);
    if (!handle || (allowedHandles && !allowedHandles.includes(handle))) return;
    if (dynamicCollection) {
      const prefix = collectionUrl.pathname.split('/collections/')[0];
      url.pathname = prefix + '/products/' + handle;
    } else {
      url.pathname = collectionUrl.pathname.replace(/\/$/, '') + '/products/' + handle;
    }
    const href = url.pathname + url.search + url.hash;
    if (link.getAttribute('href') !== href) link.setAttribute('href', href);
  }
  function updateTree(root) {
    if (!(root instanceof Element)) return;
    if (root.matches('a[href]')) updateLink(root);
    root.querySelectorAll('a[href]').forEach(updateLink);
  }
  function remember(event) {
    const link = event.target.closest('a[href]');
    if (!link || !main.contains(link)) return;
    const clicked = productHandle(link);
    if (!products.some(p => p.handle === clicked)) return;
    const order = [];
    for (const element of main.querySelectorAll('a[href]')) {
      const handle = productHandle(element);
      const product = products.find(p => p.handle === handle);
      if (product && !order.some(p => p.handle === handle)) order.push(product);
    }
    try { sessionStorage.setItem(key, JSON.stringify({locale, time: Date.now(), back: location.pathname + location.search, products: order})); } catch {}
  }
  main.addEventListener('click', remember, true);
  main.addEventListener('auxclick', remember, true);
  updateTree(main);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') updateLink(record.target);
      else record.addedNodes.forEach(updateTree);
    }
  }).observe(main, {childList: true, subtree: true, attributes: true, attributeFilter: ['href']});
})();
